import { z } from 'zod'

// request to deliver a one-off test Telegram notification previewing the enriched message for a
// chosen expected payment. `kind` selects which format: the cross-account upcoming announcement
// (📅) or the per-account received payment (💰).
export const sendTestPaymentNotificationSchema = z.object({
  expectedPaymentId: z.string().uuid(),
  kind: z.enum(['upcoming', 'received']),
})

export type SendTestPaymentNotificationDto = z.infer<typeof sendTestPaymentNotificationSchema>
